// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "PageHeader-module--bx--text-truncate--end--b8JtW";
export var bxTextTruncateFront = "PageHeader-module--bx--text-truncate--front--WwZFh";
export var darkMode = "PageHeader-module--dark-mode--WCeH8";
export var pageHeader = "PageHeader-module--page-header--NqfPe";
export var text = "PageHeader-module--text--Er2EO";
export var withTabs = "PageHeader-module--with-tabs--vbQ-W";